import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { axios } from "../../../../../Global";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import { BiDotsVerticalRounded, BiEdit, BiHide, BiShow } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import ContractCostSheetEdit from "../ContractCostSheetEdit";
import ContractFileUpload from "../ContractFileUpload";
import ContractAdvancedSecurityTable from "../ContractAdvancedSecurity";
import ProceedToProject from "../ProceedToProjectPopup";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import ContractViewFirstTable from "./ContractViewFirstTable";
import ContractClientDetailsTable from "./ContractClientDetailsTable";

const ContractCompanyDetailsTable = ({ contractDetails }) => {
  let companyDetails = contractDetails?.visa_provider;
  console.log(companyDetails,"visa provider detials")

  const VisaProviderDetials = [
    {
      title: "Company ID",
      value: companyDetails?.company_id,
    },
    {
      title: "Company Logo",
      value: companyDetails?.logo,
      image: true,
    },
    {
      title: "COMPANY NAME ENGLISH",
      value: companyDetails?.name,
    },
     {
      title: "COMPANY NAME ARABIC",
      value: companyDetails?.name_arabic,
    },
     {
      title: "Company Email",
      value: companyDetails?.email,
    },
    {
      title: "Company Landline Number",
      value: companyDetails?.mobile,
    },
    {
      title: "NATIONAL ADDRESS ENGLISH",
      value: companyDetails?.address,
    },
     {
      title: "NATIONAL ADDRESS ARABIC",
      value: companyDetails?.address_arabic,
    },
     {
      title: "PO BOX",
      value: companyDetails?.po_box,
    },
     {
      title: "PIN CODE",
      value: companyDetails?.pincode,
    },
    {
      title: "NATIONAL IDENTITY NO",
      value: companyDetails?.national_identification_number,
    },
    {
      title: "HEAD OFFICE LOCATION",
      value: companyDetails?.head_office_location,
    },
    {
      title: "CR NUMBER",
      value: companyDetails?.company_registration,
    },
    {
      title: "LABOR OFFICE FILE NUMBER (MOL)",
      value: companyDetails?.labor_license_number,
    },
    {
      title: "Company Sponsor ID (700 series)",
      value: companyDetails?.sponsor_id,
    },
    {
      title: "VAT NUMBER",
      value: companyDetails?.vat_number,
    },
    {
      title: "Authorized Person Name",
      value: companyDetails?.authorized_person_name,
    },
    {
      title: "Authorized Person Contact",
      value: companyDetails?.authorized_person_contact,
    },
    {
      title: "Authorized Person Designation",
      value: companyDetails?.authorized_person_designation,
    },
    {
      title: "Authorized Person Email",
      value: companyDetails?.authorized_person_email,
    },
     {
      title: "Authorized Project Representative Name",
      value: companyDetails?.authorized_project_representative_name,
    },
    {
      title: "Authorized Project Representative Contact",
      value: companyDetails?.authorized_project_representative_contact,
    },
    {
      title: "Authorized Project Representative Designation",
      value: companyDetails?.authorized_project_representative_designation,
    },
    {
      title: "Authorized Project Representative Email",
      value: companyDetails?.authorized_project_representative_email,
    },
    {
      title: "SIGNING AUTHORITY PERSON NAME",
      value: companyDetails?.signing_authority_person_name,
    },
    {
      title: "SIGNING AUTHORITY DESIGNATION",
      value: companyDetails?.signing_authority_person_designation,
    },
     {
      title: "SIGNING AUTHORITY CONTACT",
      value: companyDetails?.signing_authority_person_contact,
    },
     {
      title: "SIGNING AUTHORITY EMAIL",
      value: companyDetails?.signing_authority_person_email,
    },
    // {
    //   title: "Sponsor Name",
    //   value: contractDetails.company?.sponsor_name,
    // },
    {
      title: "Authorized Accounts Representative Contact",
      value: companyDetails?.authorized_accounts_representative_contact,
    },
    {
      title: "Authorized Accounts Representative Designation",
      value: companyDetails?.authorized_accounts_representative_designation,
    },
    {
      title: "Authorized Accounts Representative Email",
      value: companyDetails?.authorized_accounts_representative_email,
    },
    {
      title: "Authorized Accounts Representative Name",
      value: companyDetails?.authorized_accounts_representative_name,
    },
    {
      title: "Beneficiary Bank",
      value: companyDetails?.beneficiary_bank,
    },
     {
      title: "Bank Name",
      value: companyDetails?.bank_name,
    },
    {
      title: "Bank Account Number",
      value: companyDetails?.bank_account_number,
    },
    {
      title: "Bank Branch",
      value: companyDetails?.bank_branch,
    },
    {
      title: "Bank Iban",
      value: companyDetails?.bank_iban,
    },
   
    {
      title: "Bank Type",
      value: companyDetails?.bank_type,
    },
    
  ];

  return (
    <>
      <div
        className={`grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-5 gap-y-10 bg-slate-50 shadow-md rounded-lg px-5 transition-all overflow-auto py-5 h-auto my-4
          `}
      >
        {VisaProviderDetials?.map((elem, i) => (
          <div key={i} className=" flex flex-col gap-2">
            <h2 className="font-semibold">{elem.title}</h2>
            {elem.image ? (
              <img src={`${elem.value}`} alt={elem.title} width={"100px"} />
            ) : (
              <p>{elem.value || "--"}</p>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ContractCompanyDetailsTable;
